export const APP_BRAND = {
  productName: "AquaPortal",
  adminTitle: "AquaPortal Admin",
  description: "Plataforma de gestión administrativa de AquaPortal.",
  assets: {
    sidebarLogo: "/brand/sidebar-logo.webp",
    sidebarMark: "/brand/sidebar-mark.webp",
  },
} as const;
